// extracted by mini-css-extract-plugin
export var productImage = "_w4-0";